// Chooses which Shopify MP4 rendition a Style Diaries card plays. The list comes from the
// data-akbar-style-diaries-sources attribute rendered by akbar-style-diaries-video-sources.liquid.
(() => {
  if (window.akbarStyleDiariesVideoSources) return;

  // Below the 720p rendition's average bitrate, 480p avoids stalls mid-video.
  const lowBandwidthMbps = 4.5;
  // Extra video detail above 2x density is not visible on these small cards.
  const maxPixelDensity = 2;
  // A rendition within 10% of the target width looks the same in motion.
  const sharpnessTolerance = 0.9;

  // Data saver, 2g/3g or Chrome's bandwidth estimate mark a connection that needs small files.
  function prefersLowData() {
    const connection = window.navigator?.connection;
    if (!connection) return false;
    if (connection.saveData || /2g|^3g$/.test(connection.effectiveType || '')) return true;
    return connection.downlink > 0 && connection.downlink < lowBandwidthMbps;
  }

  function readSources(wrapper) {
    try {
      return JSON.parse(wrapper.dataset.akbarStyleDiariesSources || '[]')
        .filter(source => source.url && source.width > 0 && source.height > 0)
        .sort((a, b) => a.width - b.width);
    } catch {
      return [];
    }
  }

  // Shopify's video_tag emits only the largest MP4; pick the smallest rendition that suits the card.
  function chooseSource(wrapper) {
    const sources = readSources(wrapper);
    if (!sources.length) return null;
    if (prefersLowData()) return sources[0];
    const box = wrapper.getBoundingClientRect();
    // Cards use object-fit: contain, so a tall video is limited by the card height.
    const shown = Math.min(box.width, box.height * sources[0].width / sources[0].height);
    if (!(shown > 0)) return null;
    const density = Math.min(window.devicePixelRatio || 1, maxPixelDensity);
    const needed = shown * density * sharpnessTolerance;
    return sources.find(source => source.width >= needed) || sources[sources.length - 1];
  }

  // Put the chosen rendition ahead of video_tag's source; if it cannot load, the browser uses the original.
  function preferSource(video, source) {
    const original = video.querySelector('source');
    if (!source || !original || original.getAttribute('src') === source.url) return;
    const preferred = original.cloneNode(false);
    preferred.setAttribute('src', source.url);
    original.before(preferred);
  }

  window.akbarStyleDiariesVideoSources = {
    prefersLowData,
    apply: (wrapper, video) => preferSource(video, chooseSource(wrapper))
  };
})();
